// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__tFr1T","mainCard":"App_mainCard__2p985"};